'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecurityManager = function () {
  function SecurityManager() {
    _classCallCheck(this, SecurityManager);

    this.cryptoSubtle = typeof window.crypto !== 'undefined' ? window.crypto.subtle || window.crypto.webkitSubtle : null;
    this.textDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8') : null;
    this.textEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : null;

    this.salt = 'aaaabbbbccccdddd This is NOT secret!!';
    this.passphraseAlgorithm = {
      name: 'PBKDF2'
    };
    this.keyAlgorithm = {
      name: 'PBKDF2',
      hash: 'SHA-512',
      iterations: 1000,
      salt: this.textEncoder ? this.textEncoder.encode(this.salt) : null
    };
    this.encryptionAlgorithm = {
      name: 'AES-CBC',
      length: 256
    };
    this.decryptionAlgorithm = {
      name: 'AES-CBC'
    };
    this.iv = null;
    this.key = null;
  }

  _createClass(SecurityManager, [{
    key: 'setDataKey',
    value: function setDataKey(passphrase) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.passphraseKey(passphrase).then(function (passphraseKey) {
          _this.encryptionKey(passphraseKey).then(function (dataKey) {
            _this.key = dataKey;
            resolve();
          }, reject).catch(reject);
        }, reject).catch(reject);
      });
    }
  }, {
    key: 'passphraseKey',
    value: function passphraseKey(passphrase) {
      return this.cryptoSubtle.importKey('raw', this.textEncoder.encode(passphrase), this.passphraseAlgorithm, false, ['deriveKey']);
    }
  }, {
    key: 'encryptionKey',
    value: function encryptionKey(key) {
      return this.cryptoSubtle.deriveKey(this.keyAlgorithm, key, this.encryptionAlgorithm, true, ['encrypt', 'decrypt']);
    }
  }, {
    key: 'encryptData',
    value: function encryptData(data) {
      var _this2 = this;

      this.iv = new Uint8Array(16);
      window.crypto.getRandomValues(this.iv);

      return new Promise(function (resolve, reject) {
        _this2.encrypt(_this2.textEncoder.encode(data), _this2.key, _this2.iv).then(function (encryptedData) {
          var result = new Uint8Array(_this2.iv.byteLength + encryptedData.byteLength);
          result.set(_this2.iv, 0);
          result.set(new Uint8Array(encryptedData), _this2.iv.byteLength);
          resolve(result);
        }, reject).catch(reject);
      });
    }
  }, {
    key: 'decryptData',
    value: function decryptData(data) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.iv = data.slice(0, 16);
        var encryptedData = data.slice(16);

        if (encryptedData.byteLength > 0) {
          _this3.decrypt(encryptedData, _this3.key, _this3.iv).then(function (decryptedData) {
            resolve(_this3.textDecoder.decode(decryptedData));
          }, reject).catch(reject);
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: 'encrypt',
    value: function encrypt(data, key, iv) {
      var algorithm = Object.assign({}, this.encryptionAlgorithm);
      algorithm.iv = iv;

      return this.cryptoSubtle.encrypt(algorithm, key, data);
    }
  }, {
    key: 'decrypt',
    value: function decrypt(data, key, iv) {
      var algorithm = Object.assign({}, this.decryptionAlgorithm);
      algorithm.iv = iv;

      return this.cryptoSubtle.decrypt(algorithm, key, data);
    }
  }]);

  return SecurityManager;
}();

exports.default = SecurityManager;


//////////////////
// WEBPACK FOOTER
// ./js/lib/SecurityManager.js
// module id = 2
// module chunks = 0